import { render, staticRenderFns } from "./CoursewareVideoBlock.vue?vue&type=template&id=6c34dd30&scoped=true&"
import script from "./CoursewareVideoBlock.vue?vue&type=script&lang=js&"
export * from "./CoursewareVideoBlock.vue?vue&type=script&lang=js&"
import style0 from "./CoursewareVideoBlock.vue?vue&type=style&index=0&id=6c34dd30&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c34dd30",
  null
  
)

export default component.exports